import {
  TerratalkLiveActionNames,
  TerratalkLiveNamespace
} from "@tt-app/store/terratalkLive/types";

let stateRequestInterval: NodeJS.Timeout;

export const terratalkLivePlugin = (store: any) => {
  if (stateRequestInterval) {
    clearInterval(stateRequestInterval);
  }

  stateRequestInterval = setInterval(() => {
    if (!store.state.user.authentication.token) return;

    store.dispatch(`${TerratalkLiveNamespace}/${TerratalkLiveActionNames.REQUEST_STATE}`);
  }, 5000);
};
